import classnames from "classnames";
import React from "react";
import BlinkingComponent from "../BlinkingComponent/BlinkingComponent";

// tslint:disable-next-line:no-var-requires
const styles = require("./BonusPanel.scss");

export interface BonusPanelProps {
    readonly bonusValue: string;
    readonly className?: string;
    readonly formatBonus: (value: string) => string;
}

export interface BonusPanelState {
    readonly blinking: boolean;
}

export default class BonusPanel extends React.Component<
    BonusPanelProps,
    BonusPanelState
> {
    private blinkingTimeout?: number;

    constructor(props: BonusPanelProps) {
        super(props);
        this.state = { blinking: false };
    }

    public componentDidUpdate(prevProps: BonusPanelProps) {
        this.handleBlinking(prevProps.bonusValue, this.props.bonusValue);
    }

    public render() {
        return (
            this.props.bonusValue && (
                <BlinkingComponent
                    className={classnames(styles.bonus, this.props.className)}
                    blinking={this.state.blinking}
                    formatValue={this.props.formatBonus}
                    value={this.props.bonusValue}
                />
            )
        );
    }

    public componentWillUnmount() {
        if (this.blinkingTimeout) {
            window.clearTimeout(this.blinkingTimeout);
        }
    }

    private handleBlinking = (oldBalance: string, newBalance: string) => {
        if (oldBalance !== newBalance) {
            if (this.blinkingTimeout != null) {
                window.clearTimeout(this.blinkingTimeout);
            }
            this.setState({ blinking: true });
            this.blinkingTimeout = window.setTimeout(
                () =>
                    this.setState({
                        blinking: false
                    }),
                20000
            );
        }
    };
}
